<template>
    <div class="box event-container">
        <div class="event" v-for="(events, index) in groupedData" :key="index">
            <div class="event-name">
                <span>
                    <img :src="bulletIcon" alt="Bullet" class="bullet-image" />
                </span>
                <span style="margin-left: 5px">
                    {{
                        events.status_title.replace("Shipment", "") | uppercase
                    }}
                </span>
                <span class="event-date"
                    >({{ events.status_date | toFullDate }})</span
                >
            </div>
            <div
                class="event-description-toggle"
                @click="logDetails('event-description' + index)"
            >
                view details
            </div>
            <div
                class="event-description"
                :ref="'event-description' + index"
                v-show="'' + firstkey === '' + index"
            >
                <div
                    class="event-details"
                    v-for="(event, eventKey) in events.events"
                    :key="eventKey"
                >
                    <p><b>Date:</b> {{ event.date | toFullDate }}</p>
                    <p><b>Location:</b> {{ event.location }}</p>
                    <p><b>Comment:</b> {{ event.comment }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tracking: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            groupedData: {},
            firstkey: 0,
            bulletIcon: require("../assets/completed.svg")
        };
    },
    created() {
        this.groupStatuses();
    },
    filters: {
        uppercase(value) {
            return value.toUpperCase();
        }
    },
    methods: {
        groupStatuses() {
            this.tracking.trackings.map((value, index) => {
                if (
                    typeof this.groupedData["A" + value.status_code] ===
                        "undefined" &&
                    value.status !== null
                ) {
                    this.groupedData["A" + value.status_code] = {
                        status_title: value.status,
                        status_date: value.date,
                        events: []
                    };
                }
                if (this.firstkey === 0) {
                    this.firstkey = "A" + value.status_code;
                }
                if (
                    typeof this.groupedData["A" + value.status_code] !==
                    "undefined"
                ) {
                    this.groupedData["A" + value.status_code].events.push(
                        value
                    );
                }
            });
        },
        logDetails(data) {
            let display = "block";
            if (this.$refs[data][0].style.display === "block") {
                display = "none";
            }
            this.$refs[data][0].style.display = display;
        }
    }
};
</script>
<style scoped>
.event-container {
    padding-left: 60px;
}
.event {
    padding-top: 20px;
    padding-bottom: 20px;
    border-left: solid 2px #007bff;
}
.event-name {
    font-size: 1.4rem;
    font-weight: bold;
    letter-spacing: 1.2px;
}
.event-date {
    font-weight: normal;
    font-size: 1.4rem;
    vertical-align: middle;
}
.event-description-toggle {
    margin-left: 20px;
    text-decoration: underline;
    cursor: pointer;
    font-size: 1.2rem;
    letter-spacing: 1.6px;
}
.event-details {
    margin-top: 10px;
    margin-bottom: 10px;
}
.event-description {
    margin-left: 20px;
    font-size: 1.2rem;
    letter-spacing: 1.2px;
}
.bullet-image {
    margin-left: -13px;
    vertical-align: middle;
}

@media screen and (max-width: 760px) {
    .event-container {
        padding-left: 30px;
    }
    .event-date {
        display: table-cell;
        padding-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ShipmentJourney.vue